import { Injectable } from '@angular/core';
import { APIService } from './api.service';
import { Utility } from '@shared/services/utility.abstract';

@Injectable({
  providedIn: 'root'
})
export class BookingMessagesService {

  constructor(private readonly apiService: APIService) { }

  createBookingMessage(request: any) {
    return this.apiService.postWithAllResponse('BookingSlot/SaveBookingMessage', request)
  }

  getBookingMessage(request){
    return this.apiService.postWithAllResponse('BookingSlot/getBookingMessage', request)
  }
  
  getBookingMessageList(request){
    return this.apiService.postWithAllResponse('BookingSlot/getBookingMessageList',request)
  }

  getBookingDetailById(bookingId: string) {
    const timeZone = Utility.getLocalTimeZone();
    return this.apiService.get(`BookingSlot/getBookingDetailById?id=${bookingId}&timeZone=${timeZone}`);
  }

}
